import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { FindingsRegister } from "@/components/grc/FindingsRegister";
import { ControlsTracker } from "@/components/grc/ControlsTracker";
import { EvidenceVault } from "@/components/grc/EvidenceVault";
import { RemediationKanban } from "@/components/grc/RemediationKanban";
import { TeamRACI } from "@/components/grc/TeamRACI";
import { ComplianceTrend } from "@/components/grc/ComplianceTrend";

const TABS = [
  { value: "findings", label: "Findings Register" },
  { value: "controls", label: "Controls Tracker" },
  { value: "ropa", label: "RoPA" },
  { value: "evidence", label: "Evidence Vault" },
  { value: "remediation", label: "Remediation" },
  { value: "team-raci", label: "Team RACI" },
  { value: "trend", label: "Trend" },
  { value: "board-memo", label: "Board Memo" },
];
const LIVE_TABS = TABS.filter((t) => !["ropa", "board-memo"].includes(t.value)).map((t) => t.value);

export const ZoneD = ({ assessmentId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const seg = location.pathname.split("/").pop();
  const tab = LIVE_TABS.includes(seg) ? seg : "findings";

  return (
    <section data-testid="zone-d" className="space-y-3">
      <h2 className="text-base md:text-lg font-semibold text-[#003366]">Operations Workspace</h2>
      <Tabs value={tab} onValueChange={(v) => navigate(`/assessment/${assessmentId}/${v}`)}>
        <TabsList className="bg-white border border-slate-200 h-auto p-1 flex flex-wrap justify-start">
          {TABS.map((t) => (
            <TabsTrigger key={t.value} value={t.value} data-testid={`tab-${t.value}`} className="text-xs md:text-sm">
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="findings" className="mt-4">
          <FindingsRegister assessmentId={assessmentId} />
        </TabsContent>
        <TabsContent value="controls" className="mt-4">
          <ControlsTracker assessmentId={assessmentId} />
        </TabsContent>
        <TabsContent value="evidence" className="mt-4">
          <EvidenceVault assessmentId={assessmentId} />
        </TabsContent>
        <TabsContent value="remediation" className="mt-4">
          <RemediationKanban assessmentId={assessmentId} />
        </TabsContent>
        <TabsContent value="team-raci" className="mt-4">
          <TeamRACI assessmentId={assessmentId} />
        </TabsContent>
        <TabsContent value="trend" className="mt-4">
          <ComplianceTrend assessmentId={assessmentId} />
        </TabsContent>
      </Tabs>
    </section>
  );
};
